// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"752ff3fa","82":"46d9ba24","237":"691468a1","406":"74ad5ce0","494":"28186779","798":"352e0e92","963":"dd95bd35"}[chunkId] + ".chunk.js";
};